export default "__VITE_ASSET__e2f73098__"